import type { GitLinkResult, GitRefResource, PlatformHubVersionControlSettingsResource, ProjectTemplateResource } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import type { PageRouteDefinition, QueryParamValues, QueryParamValuesSetter, UnknownQueryParam } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { RnDTeam } from "~/RnDTeam";
import type { Loader } from "~/routing/pageRegistrations/Loader";
import type { LoadingContentRender, PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { StandardLoaderContext } from "~/routing/pageRegistrations/StandardLoaderContext";
import type { StandardPageContext } from "~/routing/pageRegistrations/StandardPageContext";
import { pageAreas } from "../PageAreaContext";
export function createProjectTemplatePageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: ProjectTemplatePageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageId: string;
    owner: RnDTeam;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    isFullWidth?: boolean;
    level?: 1 | 2;
    helpContent?: () => ReactElement;
    helpTopics?: () => ReactElement;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, ProjectTemplatePageContext> {
    return {
        route,
        render: config.render,
        pageId: config.pageId,
        owner: config.owner,
        pageArea: pageAreas.platformHub,
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        level: config.level ?? 2,
        requiredPermission: { permission: Permission.PlatformHubView, wildcard: true },
        isFullWidth: config.isFullWidth ?? true,
        helpContent: config.helpContent,
        helpTopics: config.helpTopics,
    };
}
export interface ProjectTemplatePageContext extends StandardPageContext {
    projectTemplateContext: ProjectTemplateContextProps;
}
export interface ProjectTemplateVersion {
    Version: string;
    IsPreRelease: boolean;
}
export interface ProjectTemplateContextProps {
    projectTemplate: ProjectTemplateResource;
    persistenceSettings: PlatformHubVersionControlSettingsResource;
    gitRefResource: GitRefResource | undefined;
    projectTemplateLink: GitLinkResult | null;
    publishedVersions: ProjectTemplateVersion[];
    refetchPublishedVersions: () => void;
}
